export type SyncLogEntry = {
  type: 'error' | 'log';
  date: Date;
  hardError?: boolean;
  context?: string;
  error?: Error;
  level?: string;
  message?: string;
};

const pad2 = (n: number) => String(n).padStart(2, '0');

const formatTime = (date: Date) => `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;

const formatDayHeader = (date: Date) => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return `── ${date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })} (${tz}) ──`;
};

const getDateKey = (date: Date) => `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;

const formatEntry = (entry: SyncLogEntry): string => {
  const level = entry.type === 'error'
    ? (entry.hardError ? 'FAIL' : 'RETRY')
    : (entry.level || 'info').toUpperCase();
  const message = entry.type === 'error'
    ? (entry.error?.message || 'Unknown error')
    : (entry.message || '');
  return `${level.padEnd(5)} ${formatTime(entry.date)}${entry.context ? ` ${entry.context}` : ''}: ${message}`;
};

export const formatSyncLogAsText = (entries: SyncLogEntry[]): string => {
  const lines: string[] = [];
  let currentDay = '';

  for (const entry of entries) {
    const day = getDateKey(entry.date);
    if (day !== currentDay) {
      currentDay = day;
      if (lines.length > 0) lines.push('');
      lines.push(formatDayHeader(entry.date));
    }
    lines.push(formatEntry(entry));
  }

  return lines.join('\n');
};
